import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../formModules/customInputs";
import { createSubFormStart } from "../../../../Store/Slices/subFormSlice";
import { getAllUserListStart } from "../../../../Store/Slices/userSlice";
import AssignmentSubformChange from "../AssignmentSubformChange";
import { Helpers } from "../../../../Helpers";
import { getItem } from "../../../../Services/localService";
import { Button, Modal } from "react-bootstrap";
// import { Utils } from "../../../../Utils";
const AddNewModal = ({ isOpen, onClose, onSave, formsubmodules }) => {
  // console.log("formsubmodules:::", formsubmodules);
  // console.log('currentUserData:', currentUserData);
  const [storeData, setStoreData] = useState({ data: [] });
  let currentUserData = getItem("user");
  //   let [subFormFieldLabel, setSubFormFieldLabel] = useState("");
  //       let [subFormName, setSubFormName] = useState("");
  //       console.log("subFormName:", subFormName);
  //       console.log("subFormFieldLabel:", subFormFieldLabel);
  const [errors, setErrors] = useState({});
  const [userList, setUserList] = useState([]);
  const [subFormChangeModal, setSubFormChangeModal] = useState(null);
  const [defaultSubFormChangeData, setDefaultSubFormChangeData] =
    useState(null);
  // console.log("formsubmodules:", formsubmodules);
  const dispatch = useDispatch();
  const users = useSelector((state) => state?.user);
  const sections =
    formsubmodules?.assignmentSubformModules?.fields?.sections || [];
  const moduleId = formsubmodules?.assignmentSubformModules?._id;
  const [stageValue, setStageValue] = useState(null);
  const [stagePercentage, setStagePercentage] = useState(null);

  useEffect(() => {
    if (formsubmodules?.assignmentSubformModules?._id?.length > 0) {
      const hasUserField = sections.some((section) =>
        Object.values(section?.dropped_list || {})
          .flat()
          .some((field) => field?.input_type === "user")
      );
      if (hasUserField && !userList?.length) {
        dispatch(getAllUserListStart({ page: 1, count: 100 }));
      }
    }
  }, [formsubmodules, userList.length, dispatch]);

  useEffect(() => {
    if (users?.data?.length > 0) {
      setUserList(users.data);
    }
  }, [users?.data]);

  const normalizeData = (section) => {
    const defaultFields = section?.dropped_list
      ? Object.values(section.dropped_list)
        .flat()
        .reduce((acc, field) => {
          const fieldLabel = Helpers.replaceData(
            field.extra_fields?.field_label || field.id
          );
          acc[fieldLabel] = "";
          return acc;
        }, {})
      : {};

    return {
      section_name: section.section_name.replace(/\s+/g, "_"),
      section_data: defaultFields,
    };
  };

  useEffect(() => {
    if (isOpen) {
      const formattedData = sections.map((section) => normalizeData(section));
      setStoreData({ data: formattedData });
    } else {
      setStoreData({ data: [] });
    }
  }, [isOpen, formsubmodules]);

  useEffect(() => {
    if (defaultSubFormChangeData && subFormChangeModal) {
      const fieldLabel = Helpers.replaceData(subFormChangeModal?.field_label);
      const updatedValue =
        defaultSubFormChangeData?.name?.name || defaultSubFormChangeData?.name;

      setStoreData((prev) => {
        const updatedData = [...prev.data];
        if (updatedData[subFormChangeModal?.sectionIndex]) {
          updatedData[subFormChangeModal.sectionIndex].section_data[
            fieldLabel
          ] = updatedValue;
        }
        return { data: updatedData };
      });

      setSubFormChangeModal(null);
    }
  }, [defaultSubFormChangeData, subFormChangeModal]);

  const submit = () => {
    const allData = {
      data: storeData.data,
      moduleId,
      //   log_details: {
      //     user: `${currentUserData?.firstName || ""} ${currentUserData?.lastName || ""}`,
      //     details: `${subFormName} Created`,
      //   },
    };
    onSave(allData)

    // dispatch(createSubFormStart({ data: allData }));
    setErrors({});
    // onClose();
  };

  //     useEffect(() => {
  //     console.log('formsubmodules?.modules', formsubmodules?.modules);
  //     let modules = formsubmodules?.modules;
  //     if (modules) {
  //       console.log('modules?.fields?.sections', modules?.fields?.sections);
  //       setSubFormFieldLabel(Utils.getDefaultSubFormNameField(modules?.fields?.sections));
  //     }
  //   }, [formsubmodules?.modules]);

  //   useEffect(() => {
  //     console.log('subFormFieldLabel', subFormFieldLabel);
  //     if (subFormFieldLabel) {
  //       console.log('formsubmodules?.formsubmodules?.[0]', formsubmodules?.formsubmodules?.[0]);
  //       let sub = formsubmodules?.formsubmodules?.[0];
  //       console.log('sub?.data', sub?.data);
  //       console.log('formsubmodules?.modules', formsubmodules?.modules);
  //       setSubFormName(Utils.getFieldToData(subFormFieldLabel, sub?.data, formsubmodules?.modules));
  //     }
  //   }, [subFormFieldLabel]);

  //    console.log("subFormName:1", subFormName);
  //    console.log("subFormFieldLabel:1", subFormFieldLabel);
  // console.log('formsubmodules---->?', formsubmodules)
  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        className="modal-md"
      // className={`modal fade ${isOpen ? "show d-block" : ""}`}
      // tabIndex="-1"
      // role="dialog"
      >
        {/* <div
          className="modal-dialog modal-lg custom-modal-size"
          role="document"
        >
          <div className="modal-content"> */}
        <Modal.Header closeButton>
          {/* <h5 className="modal-title">Create {subFormName}</h5> */}
          <Modal.Title>Create Record</Modal.Title>
          {/* <Button
            type="button"
            className="btn-close"
            onClick={onClose}
          ></Button> */}
        </Modal.Header>
        <Modal.Body
          // className="modal-body"
          style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
        >
          <main className="col-lg-12">
            {sections.map((section, sectionIndex) => (
              <div className="row mb-40" key={sectionIndex}>
                <h6 className="sec-header pb-3 pt-2 col-12">
                  {section.section_name}
                </h6>
                {section?.dropped_list &&
                  Object.entries(section?.dropped_list || {}).map(
                    ([key, value], index) =>
                      value?.length > 0 ? (
                        <div key={index} className="col-md-12">
                          {value.map((field) => {
                            if (field?.quick_list === true) {
                              return (
                                <CustomInput
                                  modules={formsubmodules?.modules}
                                  key={field?.id}
                                  items={field}
                                  sectionIndex={sectionIndex}
                                  storeData={storeData}
                                  setStoreData={setStoreData}
                                  setErrors={setErrors}
                                  preview={false}
                                  users={userList}
                                  lookupData={formsubmodules?.lookupData}
                                  setMainModuleSubFormChangeModal={null}
                                  fromAddNewModal={true}
                                  stagePercentage={stagePercentage}
                                  setStagePercentage={setStagePercentage}
                                  stageValue={stageValue}
                                  setStageValue={setStageValue}
                                // setMainModuleSubFormChangeModal={(fieldMeta) => {
                                //   setSubFormChangeModal({
                                //     ...fieldMeta,
                                //     field_label: field.extra_fields?.field_label,
                                //     moduleId: field?.moduleId || "",
                                //     subFormId: field?.subFormId || "",
                                //     sectionIndex,
                                //     related_list_title: field?.related_list_title || "",
                                //   });
                                // }}
                                />
                              );
                            }
                            return null;
                          })}
                        </div>
                      ) : null
                  )}
              </div>
            ))}
          </main>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={submit}
          >
            Save
          </Button>
        </Modal.Footer>
        {/* </div>
        </div> */}
      </Modal>

      {subFormChangeModal && (
        <AssignmentSubformChange
          show={!!subFormChangeModal}
          handleClose={() => setSubFormChangeModal(null)}
          moduleId={subFormChangeModal?.moduleId}
          subFormId={subFormChangeModal?.subFormId}
          setDefaultSubFormChangeData={setDefaultSubFormChangeData}
          title={subFormChangeModal?.related_list_title}
        />
      )}
    </>
  );
};

export default AddNewModal;
